import { getInitState } from 'automaton/states/InitState'
import { signal } from 'services/SignalsService'

let stopStateMachine = false

async function run(state) {
  const results = []

  signal.dispatch(`STATE:IN:${state.name}`)

  for (const action of state.actions) {
    signal.dispatch(`ACTION:${action.name}`)
    results.push(await action.execute())
  }

  signal.dispatch(`STATE:OUT:${state.name}`)

  return state.transition(results.pop())
}

function next(state) {
  if (stopStateMachine) {
    return
  }
  run(state).then(next)
}

function subscribe() {
  signal.on('STATE:MACHINE:STOP', () => {
    stopStateMachine = true
  })
}

export function start() {
  subscribe()
  next(getInitState())
}
